import { createContext } from "react";

const DF_CO0003Context = createContext();

export { DF_CO0003Context };
